<template lang="pug">
.needs-meals-modal-table-component
  b-table(
    :items="_value"
    :fields="fields"
    sticky-header
    no-border-collapse
    table-class="basic-table"
    show-empty
  )
    //- ローディング
    template(#table-busy)
      .text-center.table-loading-message
        b-spinner.spinner
        span.message.align-self-center 読込み中...
    //- レコード無し
    template(#empty)
      .empty-message
        span 情報がありません
    //- フィルター後レコード無し
    template(#emptyfiltered)
      .empty-message
        span 情報がありません

    //- ヘッダートップ
    //- ライブラリに列を描画させると列結合等レイアウト&デザインが意図通りに出来ないので自作の列を作成する
    //- ライブラリが描画する列はスタイルで非表示にしている
    template(#thead-top="data")
      b-tr.first-line
        b-th.resident-group(rowspan="2")
          span 利用者グループ
        b-th.resident(rowspan="2")
          span 利用者名（部屋名）
        b-th.needs-meals(:colspan="_mealCancellationColspan")
          span 施設での食事
        b-th.control(rowspan="2")
          span 届出内容
      b-tr.second-line
        b-th.meal(v-if="displayMealRow('breakfast')")
          span 朝食
        b-th.meal(v-if="displayMealRow('lunch')")
          span 昼食
        b-th.meal(v-if="displayMealRow('snack')")
          span おやつ
        b-th.meal(v-if="displayMealRow('dinner')")
          span 夕食

    //- セル：利用者グループ
    template(#cell(residentGroup)="row")
      span {{ row.item.residentGroupName }}
    //- セル：利用者名（部屋名）
    template(#cell(resident)="row")
      span {{ row.item.residentName }}（{{ row.item.roomName }}）
    //- セル：食事キャンセル・朝食
    template(#cell(breakfast)="row")
      span(:class="getNeedMealClass(row.item, 'breakfast')") {{ getNeedMeal(row.item, 'breakfast') }}
    //- セル：食事キャンセル・昼食
    template(#cell(lunch)="row")
      span(:class="getNeedMealClass(row.item, 'lunch')") {{ getNeedMeal(row.item, 'lunch') }}
    //- セル：食事キャンセル・おやつ
    template(#cell(snack)="row")
      span(:class="getNeedMealClass(row.item, 'snack')") {{ getNeedMeal(row.item, 'snack') }}
    //- セル：食事キャンセル・夕食
    template(#cell(dinner)="row")
      span(:class="getNeedMealClass(row.item, 'dinner')") {{ getNeedMeal(row.item, 'dinner') }}
    //- セル：届出内容
    template(#cell(control)="row")
      button.btn.detail-btn(@click="onOoutingDetail(row.item)") 詳細
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import { ExtNeedsMeal } from "@/commons/services/Outings";
import { OutingSettingGetModel } from "@/commons/services/OutingSettings";

/**
 * ### 外出外泊届けテーブルコンポーネント
 */
@Component({})
export default class NeedsMealsModalTable extends Vue {
  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<NeedsMealsModalTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<NeedsMealsModalTableField>;
  /** 外出外泊届け設定 */
  @Prop()
  setting!: OutingSettingGetModel;

  get _value(): Array<NeedsMealsModalTableItem> {
    return this.value;
  }

  get _mealCancellationColspan(): number {
    if (!this.setting) {
      return 0;
    }
    return Object.values(this.setting.useNeedsMeal).filter((value) => value === true).length;
  }

  displayMealRow(mealType: MealType): boolean {
    if (!this.setting) {
      return false;
    }

    if (!this.setting.useNeedsMeal[mealType]) {
      return false;
    }
    return this.setting.useNeedsMeal[mealType];
  }

  /**
   * ### 食事の必要可否のCSSクラスを返す
   */
  public getNeedMealClass(item: NeedsMealsModalTableItem, mealType: MealType): string {
    return item[mealType] ? "need" : "unnecessary";
  }

  /**
   * ### 食事の必要可否を返す
   *
   * - 必要：〇、不要：×を返す
   */
  public getNeedMeal(item: NeedsMealsModalTableItem, mealType: MealType): string {
    return item[mealType] ? "〇" : "×";
  }

  /**
   * ### 届出内容 詳細ボタン押下イベント処理
   */
  public onOoutingDetail(item: NeedsMealsModalTableItem): void {
    this.$emit("onOoutingDetail", item);
    return;
  }
}

/** テーブルの列名の情報 */
export interface NeedsMealsModalTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/** テーブルの1行あたりの情報 */
export interface NeedsMealsModalTableItem extends ExtNeedsMeal {
  /** 利用者グループ名 */
  residentGroupName: string;
}

export enum MealType {
  /** 朝食 */
  BREAKFAST = "breakfast",
  /** 昼食 */
  LUNCH = "lunch",
  /** おやつ */
  SNACK = "snack",
  /** 夕食 */
  DINNER = "dinner"
}
</script>

<style lang="scss" scoped>
.outing-table-component {
  .detail-btn,
  .consented-btn,
  .refuse-btn {
    min-width: 57px;
  }
  .cancel-btn {
    min-width: 120px;
  }
}
</style>
